__turbopack_context__.v({
  "checkboxGroups": "checkbox-groups-module-scss-module__gxvtFW__checkboxGroups",
});
